/* eslint-disable @typescript-eslint/no-explicit-any */
import quality from "../../assets/icons/Quality_Audit.svg";
import Assistance from "../../assets/icons/Providing_Assistance.svg";
import Training from "../../assets/icons/Quality_Traning.svg";
import Evaluation from "../../assets/icons/System_Evaluation.svg";
import Qualification from "../../assets/icons/Systems_Process_Validation.svg";
import DMF from "../../assets/icons/DMF_filing.svg";
import Scientific from "../../assets/icons/Scientific_and_Technical.svg";
import FDA from "../../assets/icons/FDA_Services.svg";
import Dealing from "../../assets/icons/Dealing.svg";
import Documentation from "../../assets/icons/Instruments-1.svg";
import Carousel from "../Carousel";

const globalServiceItems = [
  { icon: quality, label: "Quality & Audit Guidance" },
  { icon: Assistance, label: "Providing Assistance for Various Certifications" },
  { icon: Training, label: "Quality Training" },
  { icon: Evaluation, label: "System Evaluation" },
  {
    icon: Qualification,
    label: "Systems, Process Validation & Qualification Documentation",
  },
  { icon: DMF, label: "DMF filing" },
  { icon: Scientific, label: "Scientific and Technical Assistance" },
  { icon: FDA, label: "FDA Related Services" },
  { icon: Documentation, label: "Documentation for QA & QC" },
  {
    icon: Dealing,
    label:
      "Dealing in Instruments/ Equipment, Specialised Disposable Items…",
  },
];

const GlobalServiceCard = ({ item }:{ item:any }) => (
  <div className="flex flex-col items-center text-center h-36 px-2">
    <img src={item.icon} alt={item.label} className="w-20 h-20" />
    <h3 className="text-[#05326D] mt-2 text-xs leading-snug break-words">
      {item.label}
    </h3>
  </div>
);

function GlobalService() {
  const serviceCards = globalServiceItems.map((item, index) => (
    <GlobalServiceCard key={index} item={item} />
  ));

  return (
    <Carousel
      title="Global Services and Solutions"
      subtitle="Multidisciplinary team of highly experienced industry experts offering compliance, regulatory affairs, and technical services to excipients and pharmaceuticals manufacturer"
      itemsPerPageConfig={{
        mobile: 1,
        tablet: 2,
        desktop: 3,
        large: 5
      }}
      backgroundColor="bg-[#f8f9fb]"
      showArrows={true}
      showDots={true}
      gap="gap-0"
      className="py-8 mt-8"
      arrowPosition="outside"
    >
      {serviceCards}
    </Carousel>
  );
}

export default GlobalService;
